document.addEventListener('DOMContentLoaded', function() {
  var videoWrappers = document.querySelectorAll('.video-wrapper');

  videoWrappers.forEach(function(wrapper) {
    var iframe = wrapper.querySelector('iframe');
    var video = wrapper.querySelector('video');

    if (video) {
      video.controls = false; // Ensure controls are hidden initially
      video.addEventListener('click', function() {
        video.controls = !video.controls; // Toggle controls on click
      });
    }

    if (iframe) {
      wrapper.addEventListener('click', function() {
        var iframeSrc = iframe.getAttribute('src');
        if (iframeSrc.indexOf('controls=1') === -1) {
          iframeSrc += (iframeSrc.indexOf('?') > -1 ? '&' : '?') + 'controls=1';
          iframe.setAttribute('src', iframeSrc);
        }
      });
    }
  });
});
